import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import PageBackground from '../components/PageBackground';
import './ContactPage.css';

const ContactPage = () => {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  // A peaceful, welcoming background image
  const imageUrl = 'https://images.unsplash.com/photo-1528315729788-b12e3a890787?auto=format&fit=crop&w=1920&q=80';

  const adminEmail = "info@anandmaya.net";
  const subject = "Inquiry from Anandmaya Website";
  const mailtoLink = `mailto:${adminEmail}?subject=${encodeURIComponent(subject)}`;

  return (
    <div className="contact-page">
      <PageBackground imageUrl={imageUrl} />
      
      <div className="contact-page-header">
        <div className="container">
          <h1>Contact Us</h1>
          <p>We are here to assist you on your spiritual journey. Reach out to us anytime.</p>
        </div>
      </div>

      <div className="contact-main-content">
        <div className="container">
          <div className="contact-grid">
            
            {/* --- Left Column: Contact Information --- */}
            <motion.div 
              className="contact-info-card"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h2>Get in Touch</h2>
              <div className="info-item">
                <div className="info-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="info-text">
                  <h4>Our Office</h4>
                  <p>
                    <strong>MAHAV TECHNOLOGIES LLP</strong><br />
                    Plot No- 274/3636, Mahadev Nagar, Laxmisagar (Khorda),<br />
                    Bhubaneswar, Khorda- 751006, Orissa, India
                  </p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <i className="fas fa-phone"></i>
                </div>
                <div className="info-text">
                  <h4>Phone</h4>
                  <p>+91-7790094555</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <div className="info-text">
                  <h4>Email</h4>
                  <p>{adminEmail}</p>
                </div>
              </div>
            </motion.div>

            {/* --- Right Column: Mailto Action --- */}
            <motion.div 
              className="contact-action-card"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h2>Send us a Message</h2>
              <p className="contact-prompt">
                Have a question about our pooja services, store products, or yoga courses? Need spiritual guidance? 
                <br /><br />
                Click the button below to send us an email directly from your favorite email application. Our support team typically responds within 24 hours.
              </p>
              
              <motion.a
                href={mailtoLink}
                className="btn btn-primary btn-large-contact"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <i className="fas fa-paper-plane"></i> Email Us Now
              </motion.a>
            </motion.div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;